import { defineStore } from 'pinia'
import { useClientStore } from './client'

export const useLockstepStore = defineStore('lockstep', {
    state: () => ({
        client: {},
        tickets: [],
        documents: [],
        echoChannel: null,
        tasks: [],
        hubspot: {},
        isLoaded: false,
    }),
    getters: {
        getClient: (state) => state.client,
        getTickets: (state) => {
            const groups = {
                submitted: [],
                progress: [],
                completed: []
            };

            state.tickets.forEach((t) => {
                if (groups[t.status]) {
                    groups[t.status].push(t);
                }
            });

            // Sort by created_at desc
            for (const key in groups) {
                groups[key].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
            }

            // Only keep groups that have tickets
            return Object.fromEntries(
                Object.entries(groups).filter(([_, arr]) => arr.length > 0)
            );
        },
        getHubspot: (state) => state.hubspot,
        getDocuments: (state) => state.documents,
        getTasks: (state) => state.tasks
    },
    actions: {
        initialize(data) {
            this.client = data?.client || {};
            this.tickets = data?.tickets || [];
            this.hubspot = data?.hubspot || {};

            const tasks = data?.tasks || [];
            // Push tasks directly to global client store first
            const clientStore = useClientStore();
            clientStore.setTasks(tasks);

            // Maintain local tasks for backward compatibility (can be removed later)
            this.tasks = tasks;
            this.documents = data?.documents?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at)) || [];
            this.isLoaded = true;
        },

        updateTicket(ticket) {
            console.log('Updating ticket from Echo', ticket);
            const existingIndex = this.tickets.findIndex(t => t.id === ticket.id);
            
            if (existingIndex !== -1) {
                // Update existing ticket
                this.tickets[existingIndex] = ticket;
            } else {
                // Add new ticket
                this.tickets.push(ticket);
            }
        },

        updateDocument(newDocument) {
            console.log('Adding new document from Echo', newDocument);
            // Check if document already exists
            const existingIndex = this.documents.findIndex(doc => doc.id === newDocument.id);
            
            if (existingIndex !== -1) {
                // Update existing document
                this.documents[existingIndex] = newDocument;
            } else {
                // Add new document at the top (most recent first)
                this.documents.unshift(newDocument);
            }
            
            // Sort by updated_at descending (most recent first)
            this.documents.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        },

        removeDocument(documentId) {
            console.log('Removing document from Echo', documentId);
            this.documents = this.documents.filter(document => document.id !== documentId);
        },

        updateTask(updatedTask) {
            console.log('Updating task', updatedTask);
            const existingIndex = this.tasks.findIndex(task => task.id === updatedTask.id);
            
            if (existingIndex !== -1) {
                // Update existing task
                this.tasks[existingIndex] = { ...this.tasks[existingIndex], ...updatedTask };
            }

            // Also update in global client store
            const clientStore = useClientStore();
            clientStore.updateTask(updatedTask);
        },

        // Subscribe
        subscribeToEcho(echo) {
            console.log('Subscribing to echo', this.client.id);
            if (this.echoChannel) return // prevent double subscription

            this.echoChannel = echo.private('lockstep.' + this.client.id)
                .listen('UserTicketUpdated', (e) => this.updateTicket(e.ticket))
                .listen('ClientDocumentUploaded', (e) => this.updateDocument(e.document))
                .listen('ClientDocumentDeleted', (e) => this.removeDocument(e.document.id))
        },

        // Unsubscribe
        unsubscribeFromEcho(echo) {
            console.log('Unsubscribing from echo', this.client.id);
            if (this.echoChannel && this.client.id) {
                try {
                    echo.leave('lockstep.' + this.client.id);
                } catch (e) {
                    // Channel might not exist, silently continue
                }
                this.echoChannel = null;
            }
        },


    }
})